<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title title">Edit Login Details</p>
    </header>
    <div>
      <section class="modal-card-body">
        <b-field label="New Password" class="old">
          <b-input type="password"
          placeholder="********"
          v-model.trim="newPassword"
          class="input-field"
          :class="{ error: $v.newPassword.$error }"
          @input="$v.newPassword.$touch()">
          </b-input>
          <div v-if="$v.newPassword.$dirty">
              <span class="error" v-if="!$v.newPassword.minLength">
                Minimum Length required is 8 characters
              </span>
            </div>
        </b-field>
        <b-field label="Confirm New Password">
          <b-input type="password" placeholder="********" v-model="editData.newPasswordConfirm" :disabled="!this.newPassword">
          </b-input>
          <div v-if="change" class="error">Password must match</div>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button cancel" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button class="button btn" @click="submit">Change</button>
      </footer>
    </div>
    <b-modal :active.sync="isEditModalActive" has-modal-card>
          <password-success
          ></password-success>
        </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { minLength } from 'vuelidate/lib/validators';
import PasswordSuccess from '@/components/modal/ResetSucess.vue';

export default {
  name: 'PasswordReset',
  components: {
    PasswordSuccess
  },
  data() {
    return {
      newPassword: '',
      editData: {
        newPasswordConfirm: ''
      },
      onEditPassword: '',
      isEditModalActive: false
    };
  },
  validations: {
    newPassword: {
      minLength: minLength(8)
    }
  },
  computed: {
    ...mapGetters(['getLoggedUser', 'getStatus']),
    change() {
      return this.newPassword !== this.editData.newPasswordConfirm;
    }
  },
  methods: {
    ...mapActions('auth', ['editPassword']),
    submit() {
      const data = {
        id: this.getLoggedUser.id,
        password: this.editData.newPasswordConfirm
      };
      this.editPassword(data);
      if (this.getStatus === 'success') {
        console.log('Success');
        this.isEditModalActive = false;
        this.$buefy.toast.open({
          message: 'Sucessful',
          type: 'is-success'
        });
        this.$emit('close');
      } else if (this.getStatus === 'error') {
        this.$buefy.toast.open({
          message: 'Uncessful process',
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style scoped>
.modal-card {
  width: 30vw !important;
}
.field {
  display: flex;
  flex-direction: column;
}
.old {
  margin-bottom: 30px !important;
}
.title {
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
  color: #000000;
}
.label {
  margin-bottom: 20px;
  width: 100% !important;
}
.control{
  width: 100%;
}
.modal-card-body {
  padding: 1.5rem 40px;
}
.modal-card-foot {
  padding: 20px 40px;
  display: flex;
  justify-content: flex-end;
}
.error {
  color: red;
  font-size: 14px;
}
.cancel {
  background: transparent;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 13px;
  color: #5051DB;
}
.btn {
  background: #3887F6;
  color: #ffffff;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  padding: 20px 40px;
}
@media screen and (max-width: 768px) {
  .modal-card {
    width: 90vw !important;
  }
}
</style>
